export default "__VITE_ASSET__qVk3r3gi__"